import {
    Chart,
    LineController,
    LineElement,
    PointElement,
    LinearScale,
    TimeScale,
    Tooltip,
    Legend,
} from 'chart.js';
import 'chartjs-adapter-date-fns';

Chart.register(LineController, LineElement, PointElement, LinearScale, TimeScale, Tooltip, Legend);

const initMileageChart = () => {
    const ctx = document.getElementById('mileageChart');
    const series = window.mileageChartSeries || {};

    if (!ctx || Object.keys(series).length === 0) {
        return;
    }

    const datasets = series.map((dataset) => ({
        label: dataset.label,
        data: dataset.data,
        borderColor: dataset.color || '#000000',
        backgroundColor: 'transparent',
        pointRadius: 3,
        tension: 0.2,
    }));

    new Chart(ctx, {
        type: 'line',
        data: { datasets },
        options: {
            responsive: true,
            plugins: {
                legend: { position: 'bottom' },
            },
            scales: {
                x: {
                    type: 'time',
                    time: { unit: 'day' },
                },
            },
        },
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMileageChart);
} else {
    initMileageChart();
}
